import React, { useEffect, useState } from 'react';
import NoInternetMessage from './NoInternetMessage';

const NetworkStatus = (props) => {

  const [isOnline, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    window.addEventListener('online', () => setOnline(true));
    window.addEventListener('offline', () => setOnline(false));
  }, []);

  return isOnline ? props.children : <NoInternetMessage />;
};

export default NetworkStatus